import React, {Component} from 'react';
//import {Table} from 'react-bootstrap'
import Button from 'react-bootstrap/Button';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
//import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import './SuperResponsiveTableStyle.css';
import {getApi} from "../App";


export class Expediente extends Component {
    constructor (props) {
        super (props);
        //'exps' es un array donde esperamos tener los detalles de los expedientes
        this.state={
            exps: [],
            expsBackup: [],
            isLoading: false,
            error: null,
            codAbogado: this.props.codAbogado,
            filtro:''
        };
        // Este enlace es necesario para hacer que `this` funcione en el callback
        this.handleClick = this.handleClick.bind(this);
        this.handleClickTramites = this.handleClickTramites.bind(this);
        this.filter = this.filter.bind(this);
        this.handleClickFilter = this.handleClickFilter.bind(this);

    }

    componentDidMount(){
        this.setState ( {isLoading: true});

        this.refreshList();
       
    }

    refreshList() {
      const codAbogado = this.state.codAbogado.toString();

      getApi().getExpendientes(codAbogado)
          .then(data => {this.setState ({exps: data, expsBackup: data, isLoading: false });})
          .catch(error => this.setState({error, isLoading: false}));
           
    }

    handleClick (e) {
      const idExpediente = e.target.dataset.id;
      
      this.props.history.push(`/expedientes/${idExpediente}/gastos`);
           
   }

   handleClickTramites (e) {
    const idExpediente = e.target.dataset.id;
    
    this.props.history.push(`/expedientes/${idExpediente}/tramites`);
         
 }   

    handleClickFilter(){
      this.setState ( {exps: this.state.expsBackup, filtro: '' })
      this.refreshList(); 
    }

    filter(event){
      var text = event.target.value
      const data = this.state.expsBackup
      const textData = text.toUpperCase()

         const newData = data.filter(function(item){
                  const itemCaratula   = (item.caratula|| '').toUpperCase()
                  const itemJuzgado    = (item.Juzgado_Descrip|| '').toUpperCase()
                  const itemSecretaria = (item.Secretaria_Descrip|| '').toUpperCase()
                  const itemCiudad     = (item.Ciudad_Descrip|| '').toUpperCase()
                  const itemTurno      = (item.Turno_Descrip|| '').toUpperCase()
                  const itemEstado     = (item.Estado_Descrip|| '').toUpperCase()
                  const itemNroExpediente = (item.nroexpediente || '').toUpperCase() 
                  const campo = itemCaratula   +  " " + 
                                    itemCaratula   + " " + 
                                    itemJuzgado    + " " + 
                                    itemSecretaria + " " + 
                                    itemCiudad     + " " + 
                                    itemTurno      + " " + 
                                    itemEstado     + " " +
                                    itemNroExpediente

                      return campo.indexOf(textData) > -1
          })

        this.setState({
            exps: newData,
            filtro: text,
            expsBackup: data
        })

   }

    render () {
        const {exps, isLoading, error} = this.state;

        if ( error ) {
            return (
               <p>Se produjo un error. {error.message}</p>
            );
        }
        if ( isLoading ) {
            return (<p>Cargando datos...</p>) ;
        }
        return (
          <div>
            <div>
            <input className="form-control" placeholder="Buscar..." value={this.state.filtro} onChange={(filtro) => this.filter(filtro)}/>
            </div>
            <Table>
              <Thead>
                <Tr>
                  <Th>Acciones</Th>
                  <Th>Causa</Th>
                  <Th>Juzgado</Th>
                  <Th>Turno</Th>
                  <Th>Secretaria</Th>
                  <Th>Ciudad</Th>
                  <Th>Estado</Th>
                  <Th>Nro. Expediente</Th>
                </Tr>
              </Thead>
              <Tbody>
                {exps.map(expediente => (
                  <Tr key={expediente.identificador}>
                    <Td>
                      <Button className="mr-2" variant="primary" data-id={expediente.identificador}
                        onClick={this.handleClick}> 
                          Gastos
                      </Button>
                      <Button className="mr-2" variant="primary" data-id={expediente.identificador}
                        onClick={this.handleClickTramites}> 
                          Trámites
                      </Button>                      
                    </Td>
                    <Td>{expediente.caratula}</Td>
                    <Td>{expediente.Juzgado_Descrip}</Td>
                    <Td>{expediente.Turno_Descrip}</Td>
                    <Td>{expediente.Secretaria_Descrip}</Td>
                    <Td>{expediente.Ciudad_Descrip}</Td>
                    <Td>{expediente.Estado_Descrip}</Td>
                    <Td>{expediente.nroexpediente}</Td>                  
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </div>
        );
    }
}
